// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Breadcrumbs_Wrapper__9j_jK","Breadcrumb":"Breadcrumbs_Breadcrumb__0nazP","Icon":"Breadcrumbs_Icon__wYMAV"};